export const PatientFileType = {
  UpperScan: 1,
  LowerScan: 2,
  BiteScan: 58,
  PatientSmiling: 15,
} as const;

export type PatientFileType = (typeof PatientFileType)[keyof typeof PatientFileType];
